<template>
    <div class="engineering">
        <el-container>
            <el-header>
                <el-form :inline="true" :model="dataForm" label-width="100px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="项目部：">
                                <el-select v-model="dataForm.deptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="selectExportBtn()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="engineerList"
                        highlight-current-row
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column label="名称" prop="name" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="金额" prop="num" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="填写金额" prop="number" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button @click="handleModifyClick(scope.row)" type="text" size="small">设置填写金额</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-main>
        </el-container>


        <el-dialog
            title="设置填写金额"
            :visible.sync="isShowModifyDialog"
            width="30%"
            :before-close="handleClose">
            <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="填写金额">
                    <el-input v-model="form.number"
                              @input="changePrice($event)"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="info" @click="cancellation">取 消</el-button>
                <el-button type="primary" @click="modifyNumber">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog
                title="导出"
                :visible.sync="isShowExportDialog"
                width="30%"
                :before-close="handleExportClose">
            <el-radio v-model="radio" label="1">金额</el-radio>
            <el-radio v-model="radio" label="2">填写金额</el-radio>
            <span slot="footer">
                <el-button type="info" @click="cancellationExport">取 消</el-button>
                <el-button type="primary" @click="defineExport">确 定</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
    import {
        getDeptListService,
        getProjectListService,
    } from '@/services/invoiceServices'
    import {
        getCostGatherTableService,
        costGatherTableService,
        setCostGatherTableService,
    } from "../../services/engineering";
    import {exportExcelService2} from "../../services/allContractServices";
    export default {
        name: "expenditureSummary",
        data(){
            return {
                dataForm:{
                    deptId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                deptList:[], //项目部列表
                projectList:[], //项目列表
                engineerList: [],
                btnAuthorize: {
                    export: { key: "export", btnEnable: false }
                },

                isShowModifyDialog: false,
                form: {
                    number: "",
                },
                selectItem: null,

                isShowExportDialog: false,
                radio: '1',
            }
        },
        methods: {
            onActive(menuCode) {
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getDeptList();
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 查询项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            query(){
                let paramsData = {
                    ...this.dataForm
                }
                getCostGatherTableService(paramsData).then( res => {
                    if(res.code == 10000000){

                        this.engineerList = [{
                            name: '合同金额',
                            type: 'contractSumPrice',
                            num:  res.data.contractSumPrice,
                            number: res.data.contractSumPriceManual,
                        },{
                            name: '核实金额',
                            type: 'checkSumPrice',
                            num:  res.data.checkSumPrice,
                            number: res.data.checkSumPriceManual,
                        },{
                            name: '预计成本',
                            type: 'expectCostPrice',
                            num:  res.data.expectCostPrice,
                            number: res.data.expectCostPriceManual,
                        },{
                            name: '实际支出',
                            type: 'actCostPrice',
                            num:  res.data.actCostPrice,
                            number: res.data.actCostPriceManual,
                        },{
                            name: '预计毛利',
                            type: 'expectGrossMargin',
                            num:  res.data.expectGrossMargin,
                            number: res.data.expectGrossMarginManual,
                        },{
                            name: '预计毛利率',
                            type: 'expectGrossMarginRate',
                            num:  res.data.expectGrossMarginRate,
                            number: res.data.expectGrossMarginRateManual,
                        },{
                            name: '实际毛利',
                            type: 'actGrossMargin',
                            num:  res.data.actGrossMargin,
                            number: res.data.actGrossMarginManual,
                        },{
                            name: '实际毛利率',
                            type: 'actGrossMarginRate',
                            num:  res.data.actGrossMarginRate,
                            number: res.data.actGrossMarginRateManual,
                        }];
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            reset(){
                this.projectList = [];
                this.engineerList = [];
                this. dataForm = {
                    deptId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                };
            },
            selectExportBtn() {
                this.isShowExportDialog = true;
            },
            exportBtn(bool){
                let params = {
                    ...this.dataForm,
                    isManualValue: bool,
                }
                costGatherTableService(params).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },

            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        this.cancellation();
                        done();
                    })
                    .catch(_ => {});
            },
            handleModifyClick(item) {
                console.log(item);
                this.selectItem = item;
                this.isShowModifyDialog = true;
            },
            modifyNumber() {
                if (!this.form.number) {
                    this.$message.error("请填写金额！");
                    return
                }
                let params = {
                    projectId: this.dataForm.projectId,
                }
                params[this.selectItem.type] = this.form.number;
                setCostGatherTableService(params).then( res => {
                    if(res.code == 10000000){
                        this.query();
                        this.form.number = '';
                        this.selectItem = null;
                        this.isShowModifyDialog = false;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            cancellation() {
                this.form.number = '';
                this.selectItem = null;
                this.isShowModifyDialog = false;
            },

            handleExportClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        this.cancellationExport();
                        done();
                    })
                    .catch(_ => {});
            },
            defineExport() {
                this.isShowExportDialog = false;
                this.exportBtn(this.radio == 2?true: false)
            },
            cancellationExport() {
                this.isShowExportDialog = false;
            },
            changePrice(value) {
                if (!value) {
                    return
                }
                let val = (value && value.split("")) || [];
                this.form.number = val.join("").match(/^[0-9]\d*(\.?\d{0,2})/g)?val.join("").match(/^[0-9]\d*(\.?\d{0,2})/g)[0]: null || null;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .engineering {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
    }
</style>
